const CITRA_ERROR_RESPONSE_CODES = {
  SIRET: {
    NOT_FOUND: "SIRET_INEXISTANT",
    SERVICE_UNAVAILABLE: "SIRENE_INJOIGNABLE"
  }
};

export { CITRA_ERROR_RESPONSE_CODES };